import { render } from "./Home.vue?vue&type=template&id=2349e92f&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2349e92f&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontend-free-natal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2349e92f"]])

export default __exports__